import { createContext } from 'react';
import { TaskCounts } from 'shared/utils/derive-task-counts';

export type TaskCountsContextProps = {
  // undefined until the private resolver publishes counts — badge readers treat
  // undefined as "not yet known" (render nothing), never as a zero count.
  counts: TaskCounts | undefined;
};

export const TaskCountsContext = createContext<TaskCountsContextProps>({
  counts: undefined,
});
